import createAction from '../services/create-action';

export const UPDATE_USER_PRIVACY_STATUS = 'user/UPDATE_USER_PRIVACY_STATUS';

export const updateUserPrivacyStatus = createAction(UPDATE_USER_PRIVACY_STATUS);




// WEBPACK FOOTER //
// ./app/actions/update-user-privacy-status.js